import script from "./FormInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormInput.vue?vue&type=script&setup=true&lang=ts"

import "./FormInput.vue?vue&type=style&index=0&id=5c986de6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c986de6"]])

export default __exports__